export const mutations = {
  token: (state, value) => (state['token'] = value),
  user: (state, value) => (state['user'] = value),
  config: (state, value) => (state['config'] = value),
  permissions: (state, value) => (state['permissions'] = value),
  modules: (state, value) => (state['modules'] = value)
};
